import {action} from "mobx";
import i18n from "../i18n";
import authorizationService from "../services/authorizationService";
import appStore from "./appStore";

class authorizationStore {
    //#region PermissionPolicy actions
    @action listPermissionPolicies = async params => {
        const resultOfRequest = await authorizationService.listPermissionPolicies(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createPermissionPolicy = async params => {
        const resultOfRequest = await authorizationService.createPermissionPolicy(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.authorization.createPermissionPolicy.successMessage", {
                ns: "common"
            })
        });
        return resultOfRequest.data;
    };

    @action updatePermissionPolicy = async params => {
        const resultOfRequest = await authorizationService.updatePermissionPolicy(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.authorization.updatePermissionPolicy.successMessage", {
                ns: "common"
            })
        });
        return resultOfRequest.data;
    };

    @action deletePermissionPolicy = async params => {
        const resultOfRequest = await authorizationService.deletePermissionPolicy(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    //#endregion

    //#region UserGroup actions
    @action listUserGroups = async params => {
        const resultOfRequest = await authorizationService.listUserGroups(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createUserGroup = async params => {
        const resultOfRequest = await authorizationService.createUserGroup(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.authorization.createUserGroup.successMessage", {
                ns: "common"
            })
        });
        return resultOfRequest.data;
    };

    @action updateUserGroup = async params => {
        const resultOfRequest = await authorizationService.updateUserGroup(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.showSuccessMessage({
            content: i18n.t("stores.authorization.updateUserGroup.successMessage", {
                ns: "common"
            })
        });
        return resultOfRequest.data;
    };

    @action deleteUserGroup = async params => {
        const resultOfRequest = await authorizationService.deleteUserGroup(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
    //#endregion
}

export default new authorizationStore();
